import { combineEpics } from 'redux-observable';
import appEpic from './appEpic';
import navEpic from './navEpic';
import sessionEpic from './sessionEpic';
import esgEpic from './esgEpic';
export default combineEpics(
	appEpic,
	navEpic,
	sessionEpic,
	esgEpic
);
